import { QuantityField } from 'menu/components/MenuModal/ModalComponents/QuantityField';
import cs from 'classnames';

interface MultipleChoiceProps {
  children: React.ReactNode;
  choiceIndex: number;
  choiceGroupIndex: number;
  disabled: boolean;
  hasChoices: boolean;
  hasNestedChoice: boolean;
  maxForSelection: number;
  outOfStock: boolean;
  quantity: number;
  updateChoice: (
    choiceIndex: number,
    choiceGroupIndex: number,
    quantity?: number,
    hasNestedChoice?: boolean,
  ) => void;
}

export const MultipleChoice: React.FC<MultipleChoiceProps> = ({
  children,
  choiceIndex,
  choiceGroupIndex,
  disabled,
  hasChoices,
  hasNestedChoice,
  maxForSelection,
  outOfStock,
  quantity,
  updateChoice,
}) => {
  const onUpdateChoiceQuantity = (
    choiceIndex: number,
    choiceGroupIndex: number,
    quantity: number,
  ) => {
    updateChoice(choiceIndex, choiceGroupIndex, quantity, hasNestedChoice);
  };

  const selectorClasses = cs(
    outOfStock && 'out-of-stock',
    disabled && 'disabled',
    'choice-selector',
  );

  return (
    <div className={selectorClasses}>
      <QuantityField
        callbackArgs={[choiceIndex, choiceGroupIndex]}
        onChange={onUpdateChoiceQuantity}
        quantity={quantity}
        min={0}
        max={maxForSelection}
        isMultipleChoice={true}
        disabled={disabled || outOfStock}
        hasSelectedNestedChoice={hasChoices && quantity > 0}
      />
      {children}
    </div>
  );
};
